export const formatCustomNumber = (number) => {
   const numValue =  new Intl.NumberFormat('en-US', {
      style: 'decimal',   maximumFractionDigits: 2, // Adjust to the number of decimal places you want
      minimumFractionDigits: 2,
    }).format(number);

    return numValue;
  };
  
